/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { logger as log } from '@common/logger';
import { HolderDetailPageService } from '@pages/HoldersDetailPage/services';

const getSrv = () => {
  return vappContainer.get<HolderDetailPageService>(
    HolderDetailPageService.displayName
  );
};

export const getHoldersDetail = async (context: any, event: any) => {
  const currentState = 'GET_HOLDERS_DETAIL';
  const method = 'getHoldersDetail';

  // @ts-ignore
  return new Promise(async (resolve, reject) => {
    try {
      log.log('context: ', context, 'event: ', event);
      const srv = getSrv();
      const shelves = await srv.agent.getfeatureHolderDetail();
      if (shelves) {
        return resolve({
          key: 'RENDER_HOLDERS_DETAIL',
          value: {
            ...(shelves || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        log.error(`error in ${method}, msg: ${msg}`);
        return reject({
          key: 'RENDER_HOLDERS_DETAIL_ERROR',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(`error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'RENDER_HOLDERS_DETAIL_ERROR',
        value: err?.message,
      });
    }
  });
};
